<template>
    <component
        :is="tag"
        :class="classes"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: 'GlassPanel',
    inheritAttrs: false,
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        variant: {
            type: String,
            default: 'panel',
            validator: v => ['panel', 'nav', 'sidebar', 'soft'].includes(v),
        },
        radius: {
            type: String,
            default: 'md',
            validator: v => ['md', 'lg', 'hero'].includes(v),
        },
        padding: {
            type: [String, Number],
            default: null,
        },
    },
    computed: {
        classes() {
            return [
                this.variant === 'panel' ? 'glass-panel' :
                    this.variant === 'nav' ? 'glass-nav' :
                        this.variant === 'sidebar' ? 'glass-sidebar' :
                            'glass-soft',
                this.radius === 'lg' ? 'glass-panel--lg' :
                    this.radius === 'hero' ? 'glass-panel--hero' : null,
                this.padding ? `pa-${this.padding}` : null,
            ].filter(Boolean)
        },
    },
}
</script>
